<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import QuestionList from './components/QuestionList';

export default {
  name: 'TrainingEditorDetails',
  components: {
    QuestionList,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      training: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
      isDownloading: false,
    };
  },
  created() {
    const { query, params } = this.urlParser('/trainingEditor/:id?', this.path);
    this.params = query;
    if (params && params.id) {
      this.params.id = params.id;
    }

    this.fetchData();
  },
  methods: {
    ...mapActions('trainingEditor', ['fetchTraining', 'saveTraining']),
    ...mapActions('trainingEditorList', ['downloadReport']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;
      if (this.params.id) {
        this.fetchTraining(this.params)
          .then(({ data }) => {
            this.training = data;
            this.updateTabTitle({
              path: this.path,
              title: this.training.name,
            });
          })
          .catch(() => {
            this.hasError = true;
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.training = { questions: [] };
        this.updateTabTitle({
          path: this.path,
          title: 'Neue Schulung',
        });
        this.isLoading = false;
      }
    },
    save() {
      if (!this.training.name) {
        this.showErrorMessage('Bitte tragen Sie eine Bezeichnung für die Schulung ein.');
      } else {
        this.isSaving = true;
        axios.post('/training', this.training)
          .then((response) => {
            this.showSuccessMessage('Die Schulung wurde gespeichert.');
            this.training = response.data;
          })
          .catch(() => {
            this.showErrorMessage('Der Speichervorgang ist fehlgeschlagen.');
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
  },
};
</script>

<template>
  <div>
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >Es ist ein Fehler beim Laden der Schulung aufgetreten.</span>

    <v-form v-else>
      <v-container fluid grid-list-lg pt-2 pa-0>

        <v-toolbar dark dense height="40" color="blue-grey lighten-2">
          <v-tooltip bottom>
            <v-btn @click="save" :loading="isSaving" icon slot="activator">
              <v-icon>save</v-icon>
            </v-btn>
            <span>Speichern</span>
          </v-tooltip>

        </v-toolbar>

        <v-layout row wrap>
          <v-flex xs6 md3 py-0>
            <v-text-field
              v-model="training.name"
              label="Bezeichnung"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex xs6 md3 py-0>
            <v-text-field
              v-model="training.videoUrl"
              label="Video URL"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex xs6 md12 py-0>
            <question-list :questions="training.questions" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<style lang="scss">

</style>
